import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { obterOuCriarPedidoAberto } from '../../pedidos/carrinho'
import { dataBRDoTexto } from '../../lib/periodo'
import { clientesDaBuscaDaFicha } from '../../produtos/botoesDaFicha'

// Botao "Adicionar ao pedido" da ficha (decisoes dela, 23/09): escolhe um
// pedido em aberto (ou cria), e abre o pedido com o codigo JA NA BUSCA. O
// produto nao entra sozinho de proposito: o sub-pedido e por marca + tabela, e
// entrar com a tabela errada abriria um 2o pedido para a mesma fabrica.
export default function JanelaAdicionarAoPedido(props: { termo: string; aoFechar: () => void }) {
  const navegar = useNavigate()
  const [escolhendoCliente, setEscolhendoCliente] = useState(false)
  const [termo, setTermo] = useState('')
  const [erro, setErro] = useState<string | null>(null)

  const abertos = useLiveQuery(async () => {
    const pedidos = await banco.pedidos.where('status').equals('aberto').filter((p) => p.apagado_em === null).toArray()
    const linhas = await Promise.all(pedidos.map(async (p) => {
      const c = await banco.clientes.get(p.cliente_id)
      return { id: p.id, numero: p.numero, data: p.data, cliente: c ? (c.nome_fantasia || c.razao_social) : '' }
    }))
    return linhas.sort((a, b) => (a.data === b.data ? b.numero.localeCompare(a.numero) : a.data < b.data ? 1 : -1))
  }, [])

  const clientes = useLiveQuery(
    () => banco.clientes.filter((c) => c.apagado_em === null && c.status === 'ativo').toArray(),
    [],
  )
  const clientesFiltrados = clientesDaBuscaDaFicha(clientes ?? [], termo)

  function irParaPedido(pedidoId: string) {
    navegar(`/pedidos/${pedidoId}?busca=${encodeURIComponent(props.termo)}`)
  }

  async function novoPedidoPara(clienteId: string) {
    // Mesma funcao do "Novo pedido" do Cliente e da Agenda: se ele ja tem um
    // pedido aberto, usa esse -- 1 aberto por cliente, como o app ja funciona.
    // Antes a falha sumia calada (minor 6 da revisao de 23/09).
    setErro(null)
    try {
      const pedido = await obterOuCriarPedidoAberto(clienteId)
      irParaPedido(pedido.id)
    } catch {
      setErro('Não deu para abrir o pedido. Tente de novo.')
    }
  }

  return (
    <div role="dialog" aria-label="Adicionar ao pedido" className="fixed inset-0 z-40 bg-black/40 flex items-end" onClick={props.aoFechar}>
      <div className="w-full max-h-[80vh] overflow-y-auto bg-white rounded-t-2xl p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <p className="font-semibold text-slate-800">Adicionar ao pedido</p>
        {!escolhendoCliente ? (
          <>
            <button type="button" onClick={() => setEscolhendoCliente(true)}
              className="w-full rounded-lg border border-dashed border-teal-700 text-teal-700 py-3 font-semibold">
              + Novo pedido
            </button>
            {/* `undefined` = ainda lendo; antes dizia "Nenhum" por um instante (minor 6). */}
            {abertos === undefined ? (
              <p className="text-sm text-slate-500">Carregando…</p>
            ) : abertos.length === 0 ? (
              <p className="text-sm text-slate-500">Nenhum pedido em aberto.</p>
            ) : (
              <ul className="divide-y divide-slate-100">
                {abertos.map((p) => (
                  <li key={p.id}>
                    <button type="button" onClick={() => irParaPedido(p.id)} className="w-full text-left py-3 flex justify-between gap-2">
                      <span className="min-w-0"><span className="block font-medium text-slate-800 truncate">{p.cliente}</span>
                        <span className="block text-xs text-slate-500">Pedido {p.numero}</span></span>
                      <span className="text-xs text-slate-500 shrink-0">{dataBRDoTexto(p.data)}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </>
        ) : (
          <>
            <label htmlFor="busca-cliente-ficha" className="block text-sm text-slate-600">Cliente</label>
            <input id="busca-cliente-ficha" value={termo} onChange={(e) => setTermo(e.target.value)}
              placeholder="Nome do cliente (mín. 2 letras)" className="w-full border border-slate-300 rounded-lg px-3 py-2" autoFocus />
            <ul className="divide-y divide-slate-100">
              {clientesFiltrados.map((c) => (
                <li key={c.id}>
                  <button type="button" onClick={() => void novoPedidoPara(c.id)} className="w-full text-left py-3 text-slate-800">
                    {c.nome_fantasia || c.razao_social}
                  </button>
                </li>
              ))}
            </ul>
            {erro !== null && <p role="alert" className="text-sm text-red-600">{erro}</p>}
            <button type="button" onClick={() => setEscolhendoCliente(false)} className="text-sm text-slate-500">← Voltar aos pedidos em aberto</button>
          </>
        )}
        <button type="button" onClick={props.aoFechar} className="w-full text-sm text-slate-500 py-2">Fechar</button>
      </div>
    </div>
  )
}
